import { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const navItems = [
  { to: '/', label: 'Dashboard', icon: '◧' },
  { to: '/imoveis', label: 'Imóveis', icon: '⌂' },
  { to: '/lancamentos', label: 'Lançamentos', icon: '≡' }
];

export function Layout({ children }: { children: ReactNode }) {
  const { logout } = useAuth();
  const loc = useLocation();
  const titulo = navItems.find((n) => n.to === loc.pathname)?.label
    ?? (loc.pathname.startsWith('/imoveis/') ? 'Imóvel' : 'Aluguéis');

  return (
    <div className="min-h-full flex flex-col sm:flex-row">
      {/* Sidebar desktop */}
      <aside className="hidden sm:flex sm:flex-col w-56 bg-slate-900 text-slate-100 p-4 gap-1">
        <div className="px-2 py-3 mb-2">
          <div className="text-lg font-bold">Aluguéis</div>
          <div className="text-xs text-slate-400">Painel pessoal</div>
        </div>
        {navItems.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.to === '/'}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg text-sm flex items-center gap-2 ${
                isActive ? 'bg-brand-600 text-white' : 'hover:bg-slate-800'
              }`
            }
          >
            <span className="opacity-70">{n.icon}</span> {n.label}
          </NavLink>
        ))}
        <div className="mt-auto">
          <button onClick={logout} className="w-full text-left px-3 py-2 rounded-lg text-sm hover:bg-slate-800 text-slate-400">
            Sair
          </button>
        </div>
      </aside>

      {/* Header mobile */}
      <header className="sm:hidden sticky top-0 z-30 bg-white border-b border-slate-200 px-4 h-14 flex items-center justify-between">
        <div className="font-semibold">{titulo}</div>
        <button onClick={logout} className="text-sm text-slate-500">Sair</button>
      </header>

      <main className="flex-1 pb-20 sm:pb-6 overflow-x-hidden">
        <div className="max-w-5xl mx-auto p-4 sm:p-6">{children}</div>
      </main>

      {/* Bottom nav mobile */}
      <nav className="sm:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 grid grid-cols-3">
        {navItems.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.to === '/'}
            className={({ isActive }) =>
              `py-3 text-center text-xs font-medium ${
                isActive ? 'text-brand-600' : 'text-slate-500'
              }`
            }
          >
            <div className="text-lg leading-none">{n.icon}</div>
            <div className="mt-0.5">{n.label}</div>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
